module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Vue Country Store")]), _vm._v(" "), _c('p', [_vm._v("A collection of useful country data and some filters which you can run over it")]), _vm._v(" "), _c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('strong', [_vm._v("Install:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Use:")]), _vm._v(" "), _c('strong', [_vm._v("Use directly as a store")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('strong', [_vm._v("Use as a module in your existing vuex store")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', [_vm._v("filters:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h4', [_vm._v("Demo")]), _vm._v(" "), _c('strong', [_c('code', [_vm._v("getCountry(" + _vm._s(_vm.iso) + ")"), _c('code')])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iso),
      expression: "iso"
    }],
    domProps: {
      "value": _vm._s(_vm.iso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.iso = $event.target.value
      }
    }
  })]), _c('p', [_vm._v("Current iso: "), _c('span', {
    staticClass: "flag-icon",
    class: "flag-icon-" + _vm.iso
  }), _vm._v(" " + _vm._s(_vm.iso))]), _vm._v("\n      Country info:\n      "), _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v(_vm._s(_vm.getCountry(_vm.iso)))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('strong', [_c('code', [_vm._v("getCountryByTimeZone(" + _vm._s(_vm.iso) + ")"), _c('code')])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tz),
      expression: "tz"
    }],
    domProps: {
      "value": _vm._s(_vm.tz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tz = $event.target.value
      }
    }
  })]), _c('p', [_vm._v("Current tz: " + _vm._s(_vm.tz))]), _vm._v("\n      Returns:\n      "), _c('code', [_vm._v(_vm._s(_vm.getCountryByTimezone(_vm.tz)))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Raw data")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v(_vm._s(_vm.rawData))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v("\nnpm install git+https://git@github.com/AppointmentGuru/VueCountry.git\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v("\nimport countrystore from 'countries/src/countrystore'\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v("\n// in store/index.js:\nvar Vue = require('vue')\nvar Vuex = require('vuex')\nVue.use(Vuex)\n\nimport countries from 'countries/src/countrystore/modules/countries'\n\nexport default new Vuex.Store({\n  modules: {\n    // ...\n    countries: countries\n  }\n})\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    The library provides some filters via a mixin:\n    "), _c('ul', [_c('li', [_vm._v("getCountry(isoCode)")]), _vm._v(" "), _c('li', [_vm._v("getCountryByTimeZone(timezone)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "prettyprint"
  }, [_vm._v("\nimport countryfilters from 'countries/src/mixins/countryfilters'\n\n// provide these as a mixin for your component:\nexport default {\n  name: 'myCoolComponent',\n  countrystore,\n  mixins: [countryfilters],\n  ...\n}\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dc68f76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Docs.vue
// module id = 190
// module chunks = 2